import { ReactNode } from 'react';

import LightbulbIcon from '../Icons/LightbulbIcon';

interface ICallOutProps {
    children: ReactNode;
    classes?: string;
    icon?: ReactNode;
    iconClasses?: string;
}

const CallOut = ({
    children,
    classes = '',
    icon = <LightbulbIcon />,
    iconClasses = 'bg-peach-300',
}: ICallOutProps) => {
    return (
        <div className={`bg-almond-300 flex p-3 rounded-lg ${classes}`}>
            <div
                className={`flex w-6 h-6 p-1 justify-center items-center gap-2 rounded-full mr-2 ${iconClasses}`}
            >
                {icon}
            </div>
            {children}
        </div>
    );
};

export default CallOut;
